import React from "react";
import camilleImg from "../../img/team_camille.jpg";
import claraImg from "../../img/accueil_concept2.jpg";

const teamMembers = [
  {
    name: "Camille",
    role: "Fondatrice de mood",
    description:
      "Moi, c’est Camille, 35 ans et créative depuis l’enfance. Passionnée par les lieux inspirants et chaleureux, je rêve depuis toujours d’un espace unique, inclusif, où chacun peut pousser la porte, quel que soit son \"mood\", et venir s’offrir une bulle de création, de douceur et de déconnexion. Ce lieu, c’est MOOD.",
    photo: camilleImg,
  },
];

function Equipe() {
  return (
    <div className="w-full min-h-screen bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-12 py-14 flex flex-col gap-10">
        <div className="flex flex-col gap-12">
          {teamMembers.map((member) => (
            <div
              key={member.name}
              className="flex flex-col md:flex-row gap-8 md:gap-10 items-center"
            >
              <div className="flex-1 w-full order-1 md:order-none">
                <div className="h-full rounded-2xl bg-white border border-orange-100 shadow-sm p-6 md:p-8 flex flex-col gap-3">
                  <h2 className="text-2xl font-bold text-slate-900">{member.name}</h2>
                  <p className="text-orange-600 font-semibold">{member.role}</p>
                  <p className="text-slate-700 leading-relaxed">{member.description}</p>
                </div>
              </div>

              <div className="flex-1 w-full order-2 md:order-none">
                <div className="rounded-2xl overflow-hidden shadow-lg bg-orange-50 h-full max-h-[600px] flex items-center justify-center">
                  <img
                    src={member.photo}
                    alt={member.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Equipe;
